import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  FaEdit,
  FaTrashAlt,
  FaPlus,
} from "react-icons/fa";
import { AiFillSetting } from "react-icons/ai";

import { Button } from "antd";
import styled from "styled-components";
import TableControl from "../../component/table/TableControl";
import FormCreateOrg from "./FormCreateOrg";
import Actions from "../../redux/actions";
import Service from "../../service/Mgt-org";

const TableExtend = styled(TableControl)``;

const ButtonAddOrg = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #05BC9B;
  color : white;
  width: fit-content;
  font-size : 16px;
  height: 40px;
`;

export default function TableMgtOrg(props) {

  const [columns, setColumns] = useState([])
  const data = useSelector((state) => state.MgtOrg.data);
  const dispatch = useDispatch();

  useEffect(() => {

    const init = async () => {
      let data = await Service.search();
      if (data) dispatch(Actions.MgtOrg.setOrg(data));
    };

    initColumn(props.permission)
    init();
  }, [dispatch, props.permission]);

  const onClickToggleFormMgt = () => {
    dispatch(Actions.popup.toggleVisible(true, "", "", <FormCreateOrg permission={props.permission}/>));
  };

  const onDelete = async (id, orgName) => {
    Swal.fire({
      icon: "question",
      title: `ยืนยันการลบหน่วยงาน/องค์กร ${orgName}`,
      showCancelButton: true,
      confirmButtonText: `ยืนยัน`,
      cancelButtonText: `ยกเลิก`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let result = await Service.delete(id);
        if (result) {
          Swal.fire({
            title: `ลบหน่วยงาน/องค์กร ${orgName} สำเร็จ`,
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            timer: 1500,
          }).then(function () {
            dispatch(Actions.MgtOrg.deleteOrg(result));
          });
        }
      }
    });
  };

  const buttonCreateOrg = (
    <ButtonAddOrg
      className="btn-add-data"
      icon={<FaPlus className="icon-add-data" />}
      onClick={onClickToggleFormMgt}
    >
      เพิ่มหน่วยงาน/องค์กร
    </ButtonAddOrg>
  );
  
  const initColumn = (permission) =>{
    const column = [
      { title: "ชื่อ", dataIndex: "name", align: "center", className: "cn allow-search", sorter: (a, b) => a.name.localeCompare(b.name),
        render: (_, record) =>{
          return record.name ? record.name : '-'
        }
      },
      { title: "หน่วยงาน/องค์กร", dataIndex: "disp_name", align: "center", className: "cn allow-search", sorter: (a, b) => a.disp_name.localeCompare(b.disp_name), },
      { title: "วันที่สร้าง", dataIndex: "create_date", align: "center", className: "cn allow-search", sorter: (a, b) => a.create_date.localeCompare(b.create_date),
        render: (_, record) => (
          <span>{record.create_date}</span>
      )},
    ];

    if(permission.indexOf("update") >= 0 || permission.indexOf("delete") >= 0){
      column.push( {
        title: <AiFillSetting />, dataIndex: "action", align: "center", className: "cell-action",
        render: (_, record) => (
          <>
            {props.permission.indexOf("update") >= 0 ? (
              <Button className="btn-edit-data" onClick={() => {
                  dispatch( Actions.popup.toggleVisible( true, "", "", <FormCreateOrg permission={props.permission} orgId={record.id} />));
                }}
              >
                <FaEdit />
              </Button>
            ) : (
              <></>
            )}
            {props.permission.indexOf("delete") >= 0 ? (
              <Button  className="btn-delete-data" onClick={() => { onDelete(record.id, record.disp_name);}}
              >
                <FaTrashAlt />
              </Button>
            ) : (
              <></>
            )}
          </>
        ),
      })
    }

    setColumns(column)
  }

  return (
    <TableExtend
      className={
        "table-mgt-list-org" + (props.className ? props.className : "")
      }
      topRightButton={
        props.permission.indexOf("create") >= 0 ? buttonCreateOrg : ""

      }
      rowKey={"id"}
      data={data}
      columns={columns}
      dataSet={1}
    />
  );
}
